{
  "MY_ACCOUNT": "My account",
  "Q_POPNR": "Pop. No",
  "SAVE_AND_DOWNLOAD_QUOTATION": "Save and Download",
  "PDF_IS_GENERATING": "The PDF is generating and will be downloaded when finished. Please do not close the browser window during this time.",
  "INCLUDED_ITEMS": "INCLUDED ITEMS",
  "SHOW_NEW_PRODUCTS": "Show new products",
  "SHOW_CAMPAIGN": "Show campaigns",
  "CART_ARTICLE_SKU_TOTAL": "{{article}} Articles",
  "TOTAL_AFTER_DISCOUNT": "Total after discount: ",
  "TOTAL_BEFORE_DISCOUNT": "Total: ",
  "Annullerad": "Cancelled",
  "Fakturerad": "Invoiced",
  "Leverans påbörjad": "Delivery started",
  "Planerad": "Planned",
  "Registrerad": "Registered",
  "SHOW_CATALOG_SELECTION": "Car-O-Liner Rep,air Solutions Catalog",
  "CATALOG_SELECTION": "Catalog Selection",
  "MARK_UP": "Mark Up (additional percentage)",
  "MY_SETUP": "My Setup",
  "CURRENCY_RATE": "Currency Rate",
  "CONFIRM_RESET": "Do you confirm to reset and have the default data again?",
  "RESET": "Reset",
  "ADD_QUOTATION_ROW": "Add quotation row",
  "ALLOWED_USERS": "Allowed users",
  "END_USER": "End user",
  "MFA_REQUIRED": "Mfa required",
  "UPLOAD_CUSTOM_LOGO": "Upload custom logo",
  "NAME_IS_REQUIRED": "Name is Required",
  "0_DISCOUNT": "0% Discount ",
  "NEW_PRODUCTS": "New products",
  "COMPANY_INFORMATION": "Company information",
  "COMPANY_NAME": "Company name",
  "ADDRESS1": "Street address",
  "ADDRESS2": "Address",
  "ZIP": "Zip code",
  "CITY": "City",
  "ORG_NUMBER": "Org. number",
  "EMAIL_ADDRESS": "Email",
  "TELEPHONE": "Telephone",
  "WEBADDRESS": "Web address",
  "QUOTATION": "Quotation",
  "NAME": "Name",
  "CUSTOMER": "Customer",
  "YOUR_REFERENCE": "Your reference",
  "PAYMENT_TERMS": "Payment terms",
  "DATE": "Date",
  "EXPIRE_DATE": "Expiration date",
  "OUR_REFERENCE": "Our reference",
  "DELIVERY_TERMS": "Delivery terms",
  "NOTES": "Notes",
  "PRICE_SUMMARY": "Price summary",
  "ART_NO": "Art. no",
  "DESCRIPTION": "Description",
  "QUANTITY": "Quantity",
  "PRICE": "Price",
  "DISCOUNT": "Discount",
  "DISCOUNTED_PRICE": "Discounted price",
  "TOTAL_PRICE": "Total price",
  "TOTAL_PRICE_AFTER_DISCOUNT": "Total price after discount",
  "PARTIAL_DELIVERY_EXPECTED": "Partial delivery, first delivery {{date}}",
  "ENTRY_IN_PROGRESS": "Entry in progress",
  "ENTERED": "Entered",
  "PICKING_IN_PROGRESS": "Picking in progress",
  "INVOICED": "Invoiced",
  "TOP_PRODUCTS": "Top products",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Spare parts",
  "TOTAL_VAT_INCLUDED": "Total VAT included: ",
  "VAT_PRECENTAGE": "VAT %",
  "VAT_VALUE": "VAT Value",
  "SAVE_AND_EMAIL_QUOTATION": "Save and Email",
  "GST_PERCENTAGE": "GST %",
  "GST_VALUE": "GST Value",
  "TOTAL_GST_INCLUDED": "Total GST included: ",
  "TO_BE_PHASED_OUT": "To be phased out",
  "TARIFF_CODE": "Tariff code",
  "REPLACES_NUMBER": "Replaces number",
  "REPLACES_PRODUCT": "Replaces product",
  "NEWS_BANNER": "New",
  "CAMPAIGN_UNTIL": "Campaign until",
  "PRESELECTED_CUSTOMER_ID": "Preselected customer ID",
  "CHANGE_ACCOUNT": "Change account"
}
